import http from "~/common/http";


/**获取用户组列表 */

function getList(params){
    return http.get('/api/customer/groups/index',{
        params:params
    })
}

/**
 * 创建用户组
 * @param params
 * @returns {*|void|AxiosPromise<any>}
 */
function create(params) {
    return http.post('/api/customer/groups/create',params)
}

/**
 *获取用户组下面的用户
 * @param groups
 * @returns {*}
 */
function getAccounts(params) {
    return http.get('/api/customer/groups/accounts', {
        params: params
    });
}

/**
 * 删除用户组
 * @param params
 * @returns {AxiosPromise}
 */
function deleteGroup(params) {
    return http.delete('/api/customer/groups/delete', {
        params: params
    });
}

/**
 * 构建用户组用户账号关系
 * @param box_id
 * @param customer_id
 * @param params
 * @returns {AxiosPromise<any>}
 */
function buildRelations(params) {
    return http.post('/api/customer/groups/build-relations',params)
}

/**
 * 移除用户组用户账号关系
 * @param box_id
 * @param customer_id
 * @param params
 * @returns {AxiosPromise<any>}
 */
function removeRelations(params) {
    return http.post('/api/customer/groups/remove-relations',params)
}


/**
 * 获取车厢配置
 */
function getBoxConfig(box_id) {
    return http.get('/api/product/default/get-box-config',{
        params: {
            group_id: box_id
        }
    });
}

export default{
    getList,
    create,
    deleteGroup,
    buildRelations,
    removeRelations,
    getAccounts,
    getBoxConfig
}


// WEBPACK FOOTER //
// ./src/services/customerGroup.js